<!--  -->
<template>
    <div>
        <van-action-sheet v-model="showCityPick">
            <div class="content">
                <van-area :area-list="areaList" value="110101" title="选择地区" @cancel="onCancel" @confirm="onConfirm" />
            </div>
        </van-action-sheet>
    </div>
</template>

<script>
import { Area } from "vant";
import { areaList } from "./area.js";
export default {
    name: "cityPicker",
    components: {
        "van-area": Area,
    },
    props: {
        showCityPick: {
            type: Boolean,
            default: false,
        },
        sex: {
            type: Object,
        },
    },
    data() {
        return {
            areaList: areaList,
            sexList: [
                { name: "男", value: 1 },
                { name: "女", value: 2 },
            ],
        };
    },

    computed: {},

    mounted() {},

    methods: {
        onConfirm(item) {
            this.$emit("update", item);
            this.$emit("update:showCityPick", false);
        },
        onCancel() {
            this.$emit("update:showCityPick", false);
        },
        onChange() {},
    },
};
</script>
<style></style>
